/**
 * Created by Qingger Corp.
 * User: ll
 * Date: 2010/07/17
 * Time: 10:02
 */

import { Vue, Component, Watch } from 'vue-property-decorator';
import { IPSService } from '@/services/ipsServices';
import { noop } from '@/util';
import { Functions } from '@/library/utils/functions';
import NewSelectSite from '@/views/components/newSelectSIte';

export enum templateState {
  ALL,
  CLOSED,
  OPEN,
}

@Component({})
export default class Postage extends Vue {
  // 搜索关键字
  public keywords = '';

  // 运费模板状态列表
  public postageTemplateStateList: ItemObject = [
    { value: templateState.ALL, text: '全部' },
    { value: templateState.CLOSED, text: '禁用' },
    { value: templateState.OPEN, text: '启用' },
  ];

  // 运费模板状态搜索条件
  public postageState = '';

  // 分页
  public page = 1;

  // 每页显示数量
  public pageSize = 10;

  // 总数
  public totalCount = 0;

  // 运费模板列表
  public postageList: Array<PostageItem> = [];

  // 加载状态
  public loadingState = true;
  // protected date = [];

  // protected defaultStart: Date;

  // protected defaultEnd: Date;

  // 方法

  /**
   * 改变模板状态 查询
   * @param val
   */
  public onStateChange(val) {
    this.loadingState = true;
    this.postageState = val;
    this.page = 1;
    this.pageSize = 10;
    this.getPostageList();
  }

  /**
   * 获取运费模板列表
   */
  public getPostageList() {
    const postParams = {
      keywords: this.keywords,
      state: this.postageState,
      page: this.page,
      pageNum: this.pageSize,
    };
    // if (this.date && this.date.length) {
    //   (postParams["startOfTime"] = Date.parse(new Date(new Date(new Date(this.date[0]).toLocaleDateString()).getTime())) / 1000),
    //     (postParams["endOfTime"] = Date.parse(new Date(new Date(new Date(this.date[1]).toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)) / 1000);
    //   if (this.date[1] - this.date[0] > 180 * 24 * 3600 * 1000) {
    //     this.$message.error("更新时间跨度不能超过6个月！");
    //     this.date = [this.defaultStart, this.defaultEnd];
    //     return;
    //   }
    // }
    IPSService.getPostageList({
      postParams,
    }).then((response) => {
      this.totalCount = response.count;
      response.list.forEach((el) => {
        el.transName = Functions.emptyVaribleHandler(el.transName);
        el.addTimeStr = Functions.timeFormat(el.addTime);
        el.empName = Functions.emptyVaribleHandler(el.empName);
        el.stateStr = el.state == 1 ? '禁用' : '启用';
      });
      this.postageList = response.list;
      this.loadingState = false;
    });
  }

  /**
   * 新增模板
   * transId = 0 新增
   * isDisabled = 1 查看
   * @params transId isDisabled
   */
  public editPostage(transId = 0, isDisabled = 0) {
    this.$router.push(`/postageInfo/${transId}/${isDisabled}`);
  }

  /**
   * 删除/禁用/启用模板 0 删除 1 禁用 2 启用
   * @param val
   */
  public editPostageState(transId, state, message) {
    this.$confirm(`是否${message}该策略?`, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then((result) => {
      if (result == 'confirm') {
        IPSService.deletePostage({
          postParams: {
            transId,
            state,
          },
        }).then((response) => {
          if (response && response.ret) {
            this.$message.success(`${message}成功`);
            this.getPostageList();
          }
        });
      }
    });
  }

  /**
   * 改变每页显示数量
   * @param {number} val
   */
  public onSizeChange(val) {
    this.page = 1;
    this.loadingState = true;
    this.pageSize = val;
    this.getPostageList();
  }

  /**
   * 切换页码
   * @param {number} val
   */
  public onPageChange(val) {
    this.loadingState = true;
    this.page = val;
    this.getPostageList();
  }

  /**
   * 搜索模板列表
   */
  public onSearchPostageList() {
    this.loadingState = true;
    this.page = 1;
    this.pageSize = 10;
    this.getPostageList();
  }

  // 列表选中
  public onHandleSelectionChange() {}

  // 周期函数
  public created() {
    // this.defaultStart = new Date(new Date(new Date().toLocaleDateString()).getTime() - 30 * 24 * 60 * 60 * 1000);
    // this.defaultEnd = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1);
    // this.date = [this.defaultStart, this.defaultEnd];
    this.getPostageList();
  }

  /**
   * 查看网点
   */
  public viewSite(val) {
    new NewSelectSite().open({ service: 'authTree', selectCodes: val, readonly: true }).then((res) => {}, noop);
  }
}
